const INITIAL_LIMIT = 10;
const BATCH_SIZE = 10;
const instances = new WeakMap();

function optionList(select) {
  return Array.from(select.options || []);
}

function selectedLabel(select) {
  const selected = optionList(select).filter((option) => option.selected);
  if (select.multiple) {
    if (!selected.length) return select.getAttribute("data-placeholder") || "Select options";
    if (selected.length === 1) return selected[0].textContent.trim();
    return `${selected.length} options selected`;
  }
  return selected.length ? selected[0].textContent.trim() : "Select an option";
}

function injectStyles() {
  if (document.getElementById("load-more-select-styles")) return;
  const style = document.createElement("style");
  style.id = "load-more-select-styles";
  style.textContent = `
    .load-more-select { position: relative; display: block; width: 100%; min-width: 0; }
    .load-more-select-native { position: absolute !important; width: 1px !important; height: 1px !important; padding: 0 !important; margin: -1px !important; overflow: hidden !important; clip: rect(0, 0, 0, 0) !important; white-space: nowrap !important; border: 0 !important; }
    .load-more-select-trigger { display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; min-height: 42px; padding: 8px 12px; border: 1px solid #d6dee7; border-radius: 6px; background: #fff; color: #34445a; font: inherit; text-align: left; cursor: pointer; transition: border-color .15s ease, box-shadow .15s ease; }
    .load-more-select-trigger:hover { border-color: #9aabba; }
    .load-more-select-trigger:focus-visible { outline: 0; border-color: #4b83bd; box-shadow: 0 0 0 3px rgba(37,99,166,.14); }
    .load-more-select-trigger[disabled] { opacity: .65; cursor: not-allowed; background: #f5f7f9; }
    .load-more-select-value { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .load-more-select-chevron { flex: 0 0 auto; color: #78889a; font-size: 11px; transition: transform .15s ease; }
    .load-more-select-trigger[aria-expanded="true"] .load-more-select-chevron { transform: rotate(180deg); }
    .load-more-select-menu { position: fixed; z-index: 2000; display: flex; flex-direction: column; max-height: min(360px, calc(100vh - 16px)); overflow: hidden; border: 1px solid #dce4eb; border-radius: 9px; background: #fff; box-shadow: 0 12px 32px rgba(27,44,65,.18); }
    .load-more-select-search { flex: 0 0 auto; width: calc(100% - 16px); min-height: 40px; margin: 8px; padding: 8px 10px; border: 1px solid #dce3ea; border-radius: 6px; color: #24364b; font: inherit; font-size: 13px; }
    .load-more-select-search:focus { outline: 0; border-color: #4b83bd; box-shadow: 0 0 0 3px rgba(37,99,166,.11); }
    .load-more-select-options { min-height: 0; overflow: auto; overscroll-behavior: contain; }
    .load-more-select-option { display: flex; align-items: center; width: 100%; min-height: 40px; padding: 9px 12px; border: 0; background: #fff; color: #34445a; font: inherit; font-size: 13px; text-align: left; overflow-wrap: anywhere; cursor: pointer; }
    .load-more-select-option:hover, .load-more-select-option[aria-selected="true"] { background: #f0f6fb; color: #245b8e; }
    .load-more-select-option:focus-visible { outline: 2px solid #4b83bd; outline-offset: -2px; }
    .load-more-select-option[disabled] { color: #9aa5b2; cursor: not-allowed; }
    .load-more-select-more { display: flex; flex: 0 0 auto; align-items: center; justify-content: center; gap: 8px; min-height: 44px; padding: 9px 12px; border: 0; border-top: 1px solid #edf1f4; background: #f8fafc; color: #286a9d; font: inherit; font-size: 12px; font-weight: 700; cursor: pointer; }
    .load-more-select-more:hover { background: #edf4fa; }
    .load-more-select-more:focus-visible { outline: 2px solid #4b83bd; outline-offset: -2px; }
    .load-more-select-empty { padding: 18px 12px; color: #738196; font-size: 13px; text-align: center; }
    @media (max-width: 480px) { .load-more-select-menu { max-width: calc(100vw - 16px); } }
  `;
  document.head.appendChild(style);
}

function closeMenu(state) {
  if (!state || !state.menu) return;
  state.menu.remove();
  state.menu = null;
  state.trigger.setAttribute("aria-expanded", "false");
  document.removeEventListener("pointerdown", state.onOutside, true);
  document.removeEventListener("keydown", state.onKeydown, true);
  window.removeEventListener("resize", state.positionMenu);
  window.removeEventListener("scroll", state.positionMenu, true);
}

function syncTrigger(state) {
  state.value.textContent = selectedLabel(state.select);
  state.trigger.disabled = state.select.disabled;
  state.wrapper.style.display = window.getComputedStyle(state.select).display === "none" ? "none" : "";
  const options = optionList(state.select);
  if (state.menu) {
    const selected = new Set(options.filter((item) => item.selected).map((item) => item.value));
    state.menu.querySelectorAll("[data-option-value]").forEach((button) => {
      button.setAttribute("aria-selected", selected.has(button.dataset.optionValue) ? "true" : "false");
    });
  }
}

function positionMenu(state) {
  if (!state.menu) return;
  const rect = state.trigger.getBoundingClientRect();
  const width = Math.min(Math.max(rect.width, 240), window.innerWidth - 16);
  const left = Math.max(8, Math.min(rect.left, window.innerWidth - width - 8));
  const roomBelow = window.innerHeight - rect.bottom - 8;
  const roomAbove = rect.top - 8;
  const placeAbove = roomBelow < 220 && roomAbove > roomBelow;
  state.menu.style.width = `${width}px`;
  state.menu.style.left = `${left}px`;
  state.menu.style.maxHeight = `${Math.max(140, Math.min(360, (placeAbove ? roomAbove : roomBelow) - 4))}px`;
  if (placeAbove) {
    state.menu.style.top = "auto";
    state.menu.style.bottom = `${window.innerHeight - rect.top + 4}px`;
  } else {
    state.menu.style.bottom = "auto";
    state.menu.style.top = `${rect.bottom + 4}px`;
  }
}

function renderOptions(state, focusMore) {
  if (!state.menu) return;
  const list = state.menu.querySelector(".load-more-select-options");
  const oldScroll = list.scrollTop;
  const query = state.search.value.trim().toLocaleLowerCase();
  const matching = optionList(state.select).filter((option) =>
    option.textContent.trim().toLocaleLowerCase().includes(query)
  );
  const visible = matching.slice(0, state.visibleCount);
  const selected = new Set(optionList(state.select).filter((item) => item.selected).map((item) => item.value));

  list.replaceChildren();
  if (!visible.length) {
    const empty = document.createElement("div");
    empty.className = "load-more-select-empty";
    empty.textContent = "No matching options";
    list.appendChild(empty);
  }
  visible.forEach((option) => {
    const item = document.createElement("button");
    item.type = "button";
    item.className = "load-more-select-option";
    item.textContent = option.textContent.trim();
    item.disabled = option.disabled;
    item.dataset.optionValue = option.value;
    item.setAttribute("role", "option");
    item.setAttribute("aria-selected", selected.has(option.value) ? "true" : "false");
    item.addEventListener("click", () => {
      if (state.select.multiple) {
        option.selected = !option.selected;
        state.select.dispatchEvent(new Event("change", { bubbles: true }));
        syncTrigger(state);
        renderOptions(state, false);
      } else {
        state.select.value = option.value;
        state.select.dispatchEvent(new Event("change", { bubbles: true }));
        syncTrigger(state);
        closeMenu(state);
        state.trigger.focus();
      }
    });
    list.appendChild(item);
  });

  const oldMore = state.menu.querySelector(".load-more-select-more");
  if (oldMore) oldMore.remove();
  if (matching.length > state.visibleCount) {
    const more = document.createElement("button");
    more.type = "button";
    more.className = "load-more-select-more";
    more.setAttribute("aria-label", `Load ${Math.min(BATCH_SIZE, matching.length - state.visibleCount)} more options`);
    more.innerHTML = `<span aria-hidden="true">＋</span> Load more (${matching.length - state.visibleCount} remaining)`;
    more.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      state.visibleCount = Math.min(state.visibleCount + BATCH_SIZE, matching.length);
      renderOptions(state, true);
    });
    state.menu.appendChild(more);
  }
  list.scrollTop = oldScroll;
  if (focusMore) state.menu.querySelector(".load-more-select-more")?.focus();
}

function openMenu(state) {
  if (state.menu || state.select.disabled) return;
  state.visibleCount = INITIAL_LIMIT;
  state.menu = document.createElement("div");
  state.menu.className = "load-more-select-menu";
  state.menu.setAttribute("role", "dialog");
  state.search = document.createElement("input");
  state.search.type = "search";
  state.search.className = "load-more-select-search";
  state.search.setAttribute("aria-label", "Search all options");
  state.search.placeholder = "Search options…";
  const list = document.createElement("div");
  list.className = "load-more-select-options";
  list.setAttribute("role", "listbox");
  list.setAttribute("aria-multiselectable", state.select.multiple ? "true" : "false");
  state.menu.append(state.search, list);
  document.body.appendChild(state.menu);
  state.trigger.setAttribute("aria-expanded", "true");
  state.positionMenu = () => positionMenu(state);
  state.positionMenu();
  state.search.addEventListener("input", () => {
    state.visibleCount = INITIAL_LIMIT;
    renderOptions(state, false);
  });
  state.onOutside = (event) => {
    if (!state.menu || state.menu.contains(event.target) || state.trigger.contains(event.target)) return;
    closeMenu(state);
  };
  state.onKeydown = (event) => {
    if (event.key === "Escape") {
      closeMenu(state);
      state.trigger.focus();
    }
  };
  document.addEventListener("pointerdown", state.onOutside, true);
  document.addEventListener("keydown", state.onKeydown, true);
  window.addEventListener("resize", state.positionMenu);
  window.addEventListener("scroll", state.positionMenu, true);
  renderOptions(state, false);
  state.search.focus();
}

function destroy(select) {
  const state = instances.get(select);
  if (!state) return;
  closeMenu(state);
  select.removeEventListener("change", state.onChange);
  select.removeEventListener("invalid", state.onInvalid);
  if (state.form) state.form.removeEventListener("reset", state.onFormReset);
  (state.labels || []).forEach((label) => label.removeEventListener("click", state.onLabelClick));
  if (state.wrapper.parentNode) {
    state.wrapper.parentNode.insertBefore(select, state.wrapper);
    state.wrapper.remove();
  }
  select.classList.remove("load-more-select-native");
  instances.delete(select);
}

function enhance(select) {
  if (!(select instanceof HTMLSelectElement)) return;
  const options = optionList(select);
  if (options.length <= INITIAL_LIMIT) {
    destroy(select);
    return;
  }
  if (instances.has(select)) {
    const state = instances.get(select);
    syncTrigger(state);
    if (state.menu) renderOptions(state, false);
    return;
  }

  injectStyles();
  const wrapper = document.createElement("div");
  wrapper.className = "load-more-select";
  const layout = window.getComputedStyle(select);
  ["width", "maxWidth", "minWidth", "margin", "flex", "gridColumn", "alignSelf"].forEach((property) => {
    wrapper.style[property] = layout[property];
  });
  const trigger = document.createElement("button");
  trigger.type = "button";
  trigger.className = "load-more-select-trigger";
  trigger.setAttribute("aria-haspopup", "listbox");
  trigger.setAttribute("aria-expanded", "false");
  trigger.setAttribute("aria-label", select.getAttribute("aria-label") || select.labels?.[0]?.textContent.trim() || "Select an option");
  const value = document.createElement("span");
  value.className = "load-more-select-value";
  const chevron = document.createElement("span");
  chevron.className = "load-more-select-chevron";
  chevron.setAttribute("aria-hidden", "true");
  chevron.textContent = "▾";
  trigger.append(value, chevron);
  trigger.addEventListener("keydown", (event) => {
    if (event.key === "ArrowDown" || event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openMenu(state);
    }
  });
  const state = { select, wrapper, trigger, value, menu: null, visibleCount: INITIAL_LIMIT, search: null };
  instances.set(select, state);
  select.parentNode.insertBefore(wrapper, select);
  wrapper.appendChild(select);
  select.classList.add("load-more-select-native");
  wrapper.appendChild(trigger);
  trigger.addEventListener("click", () => (state.menu ? closeMenu(state) : openMenu(state)));
  state.onChange = () => syncTrigger(state);
  state.onInvalid = (event) => {
    event.preventDefault();
    trigger.focus();
  };
  select.addEventListener("change", state.onChange);
  select.addEventListener("invalid", state.onInvalid);
  state.form = select.form;
  state.onFormReset = () => window.setTimeout(() => syncTrigger(state), 0);
  if (state.form) state.form.addEventListener("reset", state.onFormReset);
  state.labels = Array.from(select.labels || []);
  state.onLabelClick = (event) => {
    event.preventDefault();
    trigger.focus();
  };
  state.labels.forEach((label) => label.addEventListener("click", state.onLabelClick));
  syncTrigger(state);
}

export function enhanceSelects(root) {
  if (!root || !root.querySelectorAll) return;
  if (root.matches && root.matches("select")) enhance(root);
  root.querySelectorAll("select").forEach(enhance);
}

export function installLoadMoreSelects(Vue) {
  if (typeof document === "undefined" || window.__schoolDockLoadMoreSelects) return;
  window.__schoolDockLoadMoreSelects = true;
  injectStyles();
  const initialize = () => enhanceSelects(document);
  Vue.nextTick(initialize);
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === "childList") {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) enhanceSelects(node);
        });
        record.removedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const removedSelects = node.matches("select")
            ? [node]
            : Array.from(node.querySelectorAll("select"));
          removedSelects.forEach((select) => {
            if (!select.isConnected) destroy(select);
          });
        });
        if (record.target instanceof HTMLSelectElement) enhance(record.target);
      }
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  Vue.mixin({
    updated() {
      if (this.$el) enhanceSelects(this.$el);
    },
  });
}
